exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav__Main {\n  z-index: 9999;\n  top: 0;\n  width: 100vw;\n  padding-top: 1em;\n  justify-content: center;\n}\n\n@media only screen and (max-width: 768px) {\n  .nav__Main {\n    width: 100%;\n  }\n}\n\n.nav__Link {\n  padding: 1em;\n  text-decoration: none;\n  color: var(--secondary);\n  font-size: 1.4vw;\n}\n.activeLink {\n  color: var(--primary) !important;\n}\n\n.nav__Link:hover {\n  color: var(--primary);\n}\n\n.nav__Tabs {\n  display: flex;\n  justify-content: space-between;\n  flex:30 1;\n  overflow-x: auto;\n  white-space: nowrap;\n}", ""]);

// exports
